var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5443 6.75537C14.6098 6.42783 14.3478 6.03479 14.0202 6.03479L10.2863 5.51073L8.58314 2.10436C8.51764 1.97335 8.45213 1.90784 8.32111 1.84233C7.99358 1.64581 7.60054 1.77683 7.40402 2.10436L5.76634 5.51073L2.03243 6.03479C1.83591 6.03479 1.7049 6.1003 1.63939 6.23131C1.37736 6.49334 1.37736 6.88638 1.63939 7.14841L4.32518 9.76869L3.67011 13.5026C3.67011 13.6336 3.67011 13.7646 3.73562 13.8956C3.93214 14.2232 4.32518 14.3542 4.65272 14.1577L7.99358 12.389L11.3344 14.1577C11.3999 14.2232 11.531 14.2232 11.662 14.2232C11.7275 14.2232 11.7275 14.2232 11.793 14.2232C12.1205 14.1577 12.3826 13.8301 12.317 13.4371L11.662 9.70318L14.3478 7.0829C14.4788 7.01739 14.5443 6.88638 14.5443 6.75537Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/star_gray.9b7b0e83c6697d298eb0a953974261eb.svg";
export { ForwardRef as ReactComponent };